<style lang="scss">
    @import '~@/assets/css/var';

    .table-title {
        margin-bottom: $intervalWidth;

        &__right {
            float: right;
        }

        &__normal {
            display: inline-block;
            padding-right: $intervalWidth;

            &-type {
                width: 140px !important;

                .el-input__inner {
                    border-right: 0;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-color: #DCDFE6 !important;
                }
            }

            &-value {
                width: 240px !important;

                input, &.el-input__inner {
                    border-left: 0;
                    border-radius: 0;
                    border-color: #DCDFE6 !important;
                }

                &.el-range-editor.el-input__inner {
                    padding: 2px 10px;
                }
            }
        }
    }

    .col-set {
        .el-dialog__body {
            padding: 0 20px;
            max-height: 450px;
        }
    }
    .draggable {
        width: 250px !important;
        margin: 10px auto;
        &-item {
            position: relative;
            border: 1px solid $border;
            margin-bottom: -1px;
            padding: 10px;
            line-height: 20px;
            cursor: move;
            font-size: 12px;

            .el-switch {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: scale(0.9) translateY(-50%) !important;
            }

            &:first-child {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }

            &:last-child {
                border-bottom-right-radius: 4px;
                border-bottom-left-radius: 4px;
            }
        }

        .sortable-ghost {
            opacity: .5;
        }
    }

    .advance {
        .el-button--text {
            font-size: 16px;
        }

        .el-form-item {
            margin: 0;
        }

        &-field {
            width: 150px;
            margin: 0 10px;
        }

        &-operate {
            width: 150px;
            margin-right: 10px;
        }

        &-value {
            margin-left: 7px !important;
            .el-form-item__content > * {
                width: 220px;
            }
        }
    }

    .dropdown-size {
        .el-dropdown-menu__item {
            &.active {
                color: $main;

                i {
                    opacity: 1;
                }
            }

            &.show {
                i {
                    opacity: 1;
                }
            }

            i {
                opacity: 0;
            }
        }
    }

    .my-table-block {
        flex: 1;

        /*.el-button-group {*/
            /*.el-button {*/
                /*&:hover {*/
                    /*opacity: .7 !important;*/
                /*}*/
            /*}*/
        /*}*/

        .expand {
            padding-left: 42px;
            padding-right: 50px;
        }

        .el-table__header {
            th {
                background: #f5f7fa;
            }
        }

        .el-table__body-wrapper {
            min-height: 150px;

            .el-link {
                font-size: 12px;
            }
        }

        .caret-wrapper {
            height: 21px;

            .ascending {
                top: 0 !important;
            }

            .descending {
                bottom: 0 !important;
            }
        }


        .el-pagination {
            padding: 10px 0 0;
            text-align: right;

            .el-select .el-input {
                margin: 0;
            }

            .el-dropdown {
                i {
                    font-size: 28px;
                }
            }
        }
    }

    .el-select-dropdown__item {
        font-size: 12px;
    }

    .operate-btn {
        a + a {
            margin-left: 10px;
        }
    }
    .el-dropdown-menu__item {
        font-size: 12px !important;
    }
</style>

<template>

    <div class="my-table-block flex flex-column" v-if="loaded">
        <div class="table-title" v-show="!hideOperate">
            <slot name="left"></slot>
            <el-dropdown size="medium" v-if="batch.length > 0" @command="batchCommand">
                <el-button type="primary">
                    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu>
                    <el-dropdown-item :disabled="item.auth | auth" v-for="item in batch" :key="item.txt"
                                      :command="item">
                        {{item.txt}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <div class="table-title__right">
                <!--普通筛选-->
                <span class="table-title__normal">
                    <el-select class="table-title__normal-type" filterable v-model="normalSearchField" value-key="key"
                               @change="normalSearchChange">
                        <el-option v-for="item in normalSearchList" :key="item.key" :label="item.value"
                                   :value="item"></el-option>
                    </el-select>

                    <template v-if="normalSearchField.type === $variable.colType.SELECT">
                        <my-select class="table-title__normal-value" v-model="normalSearchValue"
                                   :placeholder="`请选择${normalSearchField.value}`"
                                   :param="normalSearchField" @change="normalSearchSave"></my-select>
                    </template>
                    <template v-else-if="normalSearchField.type === $variable.colType.DATE">
                        <el-date-picker class="table-title__normal-value" v-model="normalSearchValue" type="daterange"
                                        unlink-panels value-format="yyyy-MM-dd"
                                        start-placeholder="开始日期" end-placeholder="结束日期"
                                        @change="normalSearchSave"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-input class="table-title__normal-value" v-model="normalSearchValue"
                                  :placeholder="`请输入${normalSearchField.value}`">
                            <el-button slot="append" icon="el-icon-search" @click="normalSearchSave"></el-button>
                        </el-input>
                    </template>
                </span>

                <el-button-group v-if="!single">
                    <el-button class="btn-blue" plain icon="el-icon-search" @click="advanceSearchShow" v-if="!single">筛选
                    </el-button>
                    <el-button class="btn-blue" plain icon="el-icon-setting" @click="columnSetShow" v-if="!single">设置
                    </el-button>
                    <el-button class="btn-blue" plain icon="el-icon-refresh" @click="$emit('refresh')">刷新</el-button>
                    <slot name="right"></slot>
                </el-button-group>
                <slot name="right-out"></slot>
            </div>
        </div>
        <el-table ref="table" :data="data" class="flex-item" :size="size" stripe :border="hasLine" :height="height"
                  resizable
                  @sort-change="sort" v-loading="loading" :highlight-current-row="isShowSingleChecked"
                  @row-dblclick="handleRowDbClickChange" @row-click="handleRowClickChange" @select="handleSelect">

            <!--序号列-->
            <el-table-column align="center" fixed v-if="!hideSerial" type="index" min-width="55" label="#"></el-table-column>

            <!--多选列-->
            <el-table-column align="center" fixed v-if="!hideMultiple" type="selection" width="45"></el-table-column>

            <!--region 自定义列-->
            <template v-for="(item, index) in list">
                <el-table-column :key="index" :prop="item.key" :label="item.value" align="center"
                                 :sortable="item.hideSort ? false : 'custom'" :fixed="item.fixed"
                                 :width="item.width" :min-width="item.minWidth" show-overflow-tooltip
                                 v-if="item.viewSelf && item.viewList">
                    <template slot-scope="props">
                        <slot :name="'slot_' + item.key" :props="props">
                            <template v-if="item.keyShow">
                                {{props.row[item.keyShow]}}
                            </template>

                            <template v-else-if="item.type === $variable.colType.SELECT">
                                {{props.row[item.key + 'Name']||!item.param.keyValue?props.row[item.key +
                                'Name']:item.param.keyValue[props.row[item.key]]}}
                            </template>

                            <!--region 普通类型-->
                            <template v-else>
                                {{item.filter ? item.filter(props.row, props.column.property) :
                                props.row[item.keyShow ? item.keyShow : item.key]}}
                            </template>
                        </slot>
                        <!--endregion-->
                    </template>
                </el-table-column>
            </template>
            <!--endregion-->

            <!--操作列-->
            <el-table-column v-if="operate.length > 0" label="操作" align="center"
                             :width="operateWidth ? operateWidth : operate.length * 30 + 15" fixed="right">
                <template slot-scope="props">
                    <!--<el-button v-for="item in operate" :key="item.key" :type="item.type" :icon="item.icon"-->
                               <!--:disabled="(item.whether ? item.whether(props.row) : false) || auth(item.auth)"-->
                               <!--@click.stop="item.event(props.row)" plain size="mini">{{item.txt}}-->
                    <!--</el-button>-->
                    <div class="operate-btn">
                        <el-tooltip v-for="item in operate" :key="item.key" :content="item.txt" placement="top">
                            <el-link :type="item.type" :icon="item.icon" :underline="false"
                                     :disabled="(item.whether ? item.whether(props.row) : false) || auth(item.auth)"
                                     @click.stop="item.event(props.row)"></el-link>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination v-if="!hidePage" :current-page.sync="pageParam.current" :page-sizes="[10, 20, 50]"
                       :page-size="pageParam.size" :layout="layout" :total="pageParam.total"
                       @size-change="handleSizeChange" @current-change="handleCurrentChange">
            <el-dropdown size="medium" :hide-on-click="false" trigger="click" @command="tableSizeChange"
                         v-show="!single">
                <el-button><i class="el-icon-menu"></i></el-button>
                <el-dropdown-menu class="dropdown-size" size="medium">
                    <el-dropdown-item :class="{active : size === item.key}" v-for="item in variable.tableSize"
                                      :key="item.key"
                                      icon="el-icon-check" :command="item.key">{{item.value}}
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <el-switch v-model="hasLine" active-text="显示竖向分割线" @change="tableLineChange"></el-switch>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-pagination>

        <!--列设置-->
        <my-dialog class="col-set" :show.sync="columnSet.show" title="列设置" width="300px" hide-footer>
            <draggable class="draggable" v-model="list" @end="saveListCustom">
                <transition-group name="no">
                    <div class="draggable-item" v-for="element in list" :key="element.key">
                        {{element.value}}
                        <el-switch v-model="element.viewSelf" @change="saveListCustom" size="normal"></el-switch>
                    </div>
                </transition-group>
            </draggable>
        </my-dialog>

        <!--高级筛选-->
        <my-dialog class="advance" :show.sync="advanceSearch.show" title="设置筛选" is-cancel-event cancel-txt="重置"
                   sure-txt="筛选" cancel-icon="el-icon-refresh" width="660px" @save="advanceSearchSave"
                   @cancel="advanceSearchCancel">
            <el-form inline v-for="(item, index) in advanceSearch.list" :key="index">

                <el-button class="btn-text-red" type="text" @click="advanceSearch.list.splice(index, 1)"><i
                        class="el-icon-remove"></i></el-button>

                <el-form-item>
                    <el-select class="advance-field" v-model="item.field" placeholder="请选择字段" value-key="key">
                        <el-option v-for="field in advanceSearchList" :key="field.key" :label="field.value"
                                   :value="field"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <template v-if="!item.field">
                        <el-select v-model="item.model" disabled></el-select>
                    </template>
                    <template v-else-if="item.field.type === $variable.colType.SELECT||
                                        item.field.type === $variable.colType.DATE||
                                        item.field.type === $variable.colType.NUMBER">
                        <el-select class="advance-operate" v-model="item.operate" placeholder="请选择操作" value-key="id">
                            <el-option v-for="field in advanceSearch.operateList" :key="field.key" :label="field.value"
                                       :value="field.key"></el-option>
                        </el-select>
                    </template>
                    <template v-else>
                        <el-select class="advance-operate" v-model="item.operate" placeholder="请选择操作" value-key="id">
                            <el-option v-for="field in advanceSearch.strOperateList" :key="field.key"
                                       :label="field.value" :value="field.key"></el-option>
                        </el-select>
                    </template>
                </el-form-item>
                <el-form-item class="advance-value">
                    <template v-if="!item.field">
                        <el-input v-model="item.model" disabled></el-input>
                    </template>
                    <template v-else-if="item.field.type === $variable.colType.SELECT">
                        <my-select v-model="item.model" :placeholder="`请选择${item.field.value}`"
                                   :param="item.field"></my-select>
                    </template>
                    <template v-else-if="item.field.type === $variable.colType.DATE">
                        <el-date-picker v-model="item.model" type="datetime" unlink-panels style="width: 220px"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :placeholder="`请输入${item.field.value}`"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-input v-model="item.model" :placeholder="`请输入${item.field.value}`"></el-input>
                    </template>
                </el-form-item>
            </el-form>
            <el-button type="text" @click="advanceSearch.list.push({})"><i class="el-icon-circle-plus"></i></el-button>
        </my-dialog>
    </div>
</template>

<script>
    import help from '@/util/help';
    import variable from '@/util/variable';
    import draggable from 'vuedraggable';

    export default {
        components: {draggable},
        props: {
            // 表格里的操作列
            operate: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 列表是否在加载中
            loading: {
                type: Boolean,
                default: false
            },
            // 列的表头
            cols: {
                type: Array,
                default: () => {
                    return []
                }
            },
            stripe: {
                type: String,
            },
            operateWidth: {},
            // 表数据
            data: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 批量操作列表
            batch: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 表格唯一表示
            name: {},
            // 隐藏操作行
            hideOperate: {
                type: Boolean,
                default: false
            },
            // 表高度
            height: {
                type: Number,
                default: 250,
            },
            // 是否显示el-table的单选
            isShowSingleChecked: {
                type: Boolean,
                default: false
            },
            // 是否隐藏序列
            hideSerial: {
                type: Boolean,
                default: false
            },
            // 是否隐藏分页
            hidePage: {
                type: Boolean,
                default: false
            },
            // 是否隐藏多选列
            hideMultiple: {
                type: Boolean,
                default: false
            },
            // 是否简单类型
            single: {
                type: Boolean,
                default: false
            },
            // 页码的相关参数
            pageParam: {
                type: Object,
                default: () => {
                    return {
                        index: 1,
                        size: 20,
                        total: 0
                    }
                }
            },
            layout: {
                default: 'prev, pager, next, total, sizes, slot'
            },
        },
        data() {
            return {
                variable,
                loaded: false,
                list: [],

                // 表格尺寸
                size: help.store.get('tableSize') || variable.tableSize[0].key,
                hasLine: !!help.store.get('tableLine'),

                // 普通筛选
                normalSearchField: {},
                normalSearchValue: '',

                // 列设置
                columnSet: {
                    show: false,
                },

                // 高级查询
                advanceSearch: {
                    show: false,
                    list: [],
                    operateList: [
                        {key: 'eq', value: '等于'},
                        {key: 'ne', value: '不等于'},
                        {key: 'gt', value: '大于'},
                        {key: 'ge', value: '大于等于'},
                        {key: 'lt', value: '小于'},
                        {key: 'le', value: '小于等于'},
                    ],
                    strOperateList: [
                        {key: 'eq', value: '等于'},
                        {key: 'ne', value: '不等于'},
                        {key: 'gt', value: '大于'},
                        {key: 'ge', value: '大于等于'},
                        {key: 'lt', value: '小于'},
                        {key: 'le', value: '小于等于'},
                        {key: 'like', value: '包含'},
                    ],
                }
            }
        },
        created() {
            this.getList();
            // 赋值普通筛选
            for (let i = 0; i < this.cols.length; i += 1) {
                if (this.cols[i].searchNormal) {
                    this.normalSearchField = this.cols[i];
                    this.normalSearchChange();
                    return
                }
            }
        },
        computed: {
            // 普通筛选的列表
            normalSearchList() {
                if (this.cols && this.cols.length > 0) {
                    return (
                        this.cols.filter(item => item.searchNormal)
                    )
                }
                return []
            },
            // 高级筛选的列表
            advanceSearchList() {
                if (this.cols && this.cols.length > 0) {
                    return (
                        this.cols.filter(item => item.searchAdvance)
                    )
                }
                return []
            },
        },
        mounted() {
            this.loaded = true
        },
        methods: {
            getList() {
                if (this.cols && this.cols.length > 0) {
                    let list = help.deepClone(this.cols);

                    // 从localstorage里获取相关配置
                    const custom = help.store.get(`config_${this.name}`) || {};
                    list.map(item => {
                        if (custom[item.key]) {
                            item.viewSelf = !!custom[item.key].viewSelf;
                        } else {
                            item.viewSelf = true
                        }
                        return item;
                    })

                    list = list.sort((a, b) => {
                        return a.viewSort - b.viewSort;
                    });

                    this.list = list;
                } else {
                    this.list = []
                }
            },

            saveListCustom() {
                const param = {};
                this.list.forEach((item, index) => {
                    const obj = {};
                    obj.viewSort = index + 1;
                    obj.viewSelf = item.viewSelf ? 1 : 0;
                    param[item.key] = obj
                })
                help.store.set(`config_${this.name}`, JSON.stringify(param));
            },
            // 表格尺寸修改
            tableSizeChange(command) {
                if (command) {
                    this.size = command;
                    help.store.set('tableSize', this.size);
                    this.loaded = false
                    this.$nextTick(() => {
                        this.loaded = true
                    })
                }
            },
            tableLineChange() {
                help.store.set('tableLine', this.hasLine ? 1 : 0);
            },

            getCheckedRows() {
                return this.$refs.table.selection;
            },

            // 批量操作
            batchCommand(command) {
                const list = this.getCheckedRows();
                if (command.api) {
                    if (list.length > 0) {
                        this.$store.commit('confirm', {
                            title: '提示',
                            content: `确定${command.txt}`,
                            callback: (next, back) => {
                                const key = command.key || 'id'
                                this.$api.post(command.api, list.map(item => {
                                    const param = {}
                                    param[key] = item[key]
                                    return param
                                }))
                                    .then(res => {
                                        this.$help.success(res.errorTotalMsg)
                                        this.$emit('refresh')
                                        next()
                                    })
                                    .finally(back)
                            }
                        })
                    } else {
                        this.$help.error('请至少选择一行数据')
                    }
                } else {
                    command && command.event(list)
                }


            },

            // 普通筛选
            normalSearchChange() {
                this.normalSearchValue = '';
                // if (this.normalSearchField.type === 'das') {
                //     console.log('预留代码');
                // } else {
                //
                // }
            },
            normalSearchSave() {
                setTimeout(() => {
                    const param = {};
                    switch (this.normalSearchField.type) {
                        case variable.colType.DATE:
                            param[`${this.normalSearchField.key}Start`] = this.normalSearchValue[0] + " 00:00:00";
                            param[`${this.normalSearchField.key}End`] = this.normalSearchValue[1] + " 23:59:59";
                            break
                        case variable.colType.SELECT:
                            param[this.normalSearchField.key] = `${this.normalSearchValue}`
                            break
                        case variable.colType.NUMBER:
                            param[this.normalSearchField.key] = `${this.normalSearchValue}`
                            break
                        default:
                            param[`${this.normalSearchField.key}Like`] = this.normalSearchValue
                    }

                    this.$emit('paramChange', param);
                }, 0)
            },

            // 列设置
            columnSetShow() {
                this.columnSet.show = true;
            },

            // 高级筛选
            advanceSearchShow() {
                if (this.advanceSearch.list.length === 0) {
                    this.advanceSearch.list.push({});
                }
                this.advanceSearch.show = true;
            },
            advanceSearchCancel() {
                this.advanceSearch.list = [{}]
            },
            advanceSearchSave() {
                const param = [];
                this.advanceSearch.list.forEach(item => {
                    if (item.field && item.model && item.operate) {
                        param.push({
                            advancedFieldName: item.field.key,
                            advancedFieldValue: item.model,
                            advancedFieldOperator: item.operate
                        })
                    }
                })

                this.$emit('cndClusterChange', param)
                this.advanceSearch.show = false;
            },


            handleRowDbClickChange(row) {
                this.$emit('handleRowDbClickChange', row)
            },

            handleRowClickChange(row) {
                this.$refs.table.toggleRowSelection(row)
                this.$emit('handleRowClickChange', row)
            },
            sort(row) {
                this.$emit('sort', row)
            },
            // region 分页等操作
            handleSizeChange(val) {
                this.$emit('pageChange', {
                    size: val,
                    current: 1
                })
            },
            handleCurrentChange(val) {
                this.$emit('pageChange', {
                    current: val
                })
            },
            handleSelect(selection, row) {
                this.$emit('handleSelect', selection, row)
            },
            // endregion
        },
    }
</script>
